import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFirebase } from "../../contexts/FirebaseContext";

const Login = () => {
	const { t } = useTranslation();
	const { login, loginGoogle, resetPassword, isAuthenticated } = useFirebase();

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [resetMessage, setResetMessage] = useState("");

	const navigate = useNavigate();
	console.log(isAuthenticated());

	// Handle email/password login
	const handleLogin = async (e) => {
		e.preventDefault();
		try {
			await login(email, password);
			navigate("/dashboard");
		} catch (err) {
			setError("Invalid email or password.");
		}
	};

	// Handle Google Sign-In
	const handleGoogleSignIn = async () => {
		try {
			await loginGoogle();
			navigate("/checkin");
		} catch (err) {
			setError("Google Sign-In failed. Please try again.");
		}
	};

	// Handle forgot password
	const handleForgotPassword = async () => {
		if (!email) {
			setError("Please enter your email to reset your password.");
			return;
		}
		try {
			await resetPassword(email);
			setResetMessage("Password reset email sent. Check your inbox.");
			setError("");
		} catch (err) {
			setError("Error sending reset email. Please try again.");
		}
	};

	useEffect(() => {
		if (isAuthenticated()) navigate("/checkin");
	}, []);

	return (
		<div className="flex items-center justify-center h-screen">
			<div className="p-6 w-full max-w-[360px] border rounded-lg shadow-lg bg-white border-violet-100 max-[360px]:w-[280px] max-[400px]:w-[320px] md:w-[400px]">
				<h2 className="text-2xl font-bold text-violet-950 text-center mb-4">{t("pageLogin")}</h2>
				{error && <p className="text-red-500 text-sm text-center">{error}</p>}
				{resetMessage && <p className="text-green-500 text-sm text-center">{resetMessage}</p>}
				<form
					onSubmit={handleLogin}
					className="space-y-4">
					<div>
						<label
							htmlFor="email"
							className="block text-sm font-medium text-gray-700">
							{t("login.email")}
						</label>
						<input
							type="email"
							id="email"
							className="mt-1 p-2 w-full border rounded focus:ring focus:ring-violet-700"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
						/>
					</div>

					<div>
						<label
							htmlFor="password"
							className="block text-sm font-medium text-gray-700">
							{t("login.password")}
						</label>
						<input
							type="password"
							id="password"
							className="mt-1 p-2 w-full border rounded focus:ring focus:ring-violet-700"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
						/>
					</div>
					<button
						type="submit"
						className="py-2 w-full rounded bg-violet-700 text-white hover:bg-violet-600">
						{t("login.login")}
					</button>
				</form>

				{/* <div className="flex justify-between items-center mt-4">
          <button
            className="text-sm text-blue-500 hover:underline"
            onClick={handleForgotPassword}
          >
            {t("forgot")}
          </button>
          <button
            className="text-sm text-blue-500 hover:underline"
            onClick={() => navigate("/signup")}
          >
            {t("create")}
          </button>
        </div> */}

				{/* <div className="mt-6">
          <button
            className="py-2 w-full bg-red-700 text-white rounded hover:bg-red-600"
            onClick={handleGoogleSignIn}
          >
            {t("loginGoogle")}
          </button>
        </div> */}
			</div>
		</div>
	);
};

export default Login;
